/** A single transcript block (one speech segment with timing). */
export interface ClippingStudioTranscriptBlock {
  id: number;
  timestamp: string;
  startTimeMs: number;
  endTimeMs: number;
  text: string;
}

/** Per-language transcript track. */
export interface ClippingStudioTranscriptTrack {
  language: string;
  isOriginal: boolean;
  blocks: ClippingStudioTranscriptBlock[];
}

/** Subtitle style settings. */
export interface ClippingStudioSubtitleStyle {
  fontFamily: string;
  fontSize: number;
  fontColor: string;
  backgroundColor: string;
  /** solid = black box behind text; outline = stroked text; dropShadow = text with drop shadow only. */
  backgroundStyle: "solid" | "outline" | "dropShadow";
  position: "top" | "middle" | "bottom";
}

/**
 * Geometry and shadow values shared by the two places subtitles are rendered:
 * the preview canvas and the style panel's live text field. Keep them in sync
 * by importing, not by copying — the panel is a CSS replica of the canvas draw.
 */
export const SUBTITLE_LINE_HEIGHT_RATIO = 1.2;
/** Box padding around the text plate; halved vertically (top/bottom share it). */
export const SUBTITLE_BOX_PADDING = 24;
export const SUBTITLE_SHADOW_OFFSET_X = 2;
export const SUBTITLE_SHADOW_OFFSET_Y = 2;
export const SUBTITLE_SHADOW_BLUR = 8;
export const SUBTITLE_SHADOW_COLOR = "rgba(0,0,0,0.9)";

/** Full transcript & subtitle state for a project. */
export interface ClippingStudioTranscriptState {
  sourceAudioLanguage: string;
  activeTranscriptLanguage: string;
  transcriptTracks: ClippingStudioTranscriptTrack[];
  subtitleLanguage: string;
  subtitleStyle: ClippingStudioSubtitleStyle;
  isRegenerating: boolean;
}
